import arrow_caret_circle_down from './arrow-caret-circle-down.svg';
import arrow_caret_circle_left from './arrow-caret-circle-left.svg';
import arrow_caret_circle_right from './arrow-caret-circle-right.svg';
import arrow_caret_circle_up from './arrow-caret-circle-up.svg';
import arrow_caret_down_md from './arrow-caret-down-md.svg';
import arrow_caret_down_sm from './arrow-caret-down-sm.svg';
import arrow_caret_left_sm from './arrow-caret-left-sm.svg';
import arrow_caret_right_sm from './arrow-caret-right-sm.svg';
import arrow_caret_up_md from './arrow-caret-up-md.svg';
import arrow_caret_up_sm from './arrow-caret-up-sm.svg';
import arrow_chevron_down from './arrow-chevron-down.svg';
import arrow_chevron_down_duo from './arrow-chevron-down-duo.svg';
import arrow_chevron_left from './arrow-chevron-left.svg';
import arrow_chevron_left_duo from './arrow-chevron-left-duo.svg';
import arrow_chevron_left_md from './arrow-chevron-left-md.svg';
import arrow_chevron_right from './arrow-chevron-right.svg';
import arrow_chevron_right_duo from './arrow-chevron-right-duo.svg';
import arrow_chevron_right_md from './arrow-chevron-right-md.svg';
import arrow_chevron_up from './arrow-chevron-up.svg';
import arrow_chevron_up_duo from './arrow-chevron-up-duo.svg';
import arrow_circle_down from './arrow-circle-down.svg';
import arrow_circle_down_left from './arrow-circle-down-left.svg';
import arrow_circle_down_right from './arrow-circle-down-right.svg';
import arrow_circle_left from './arrow-circle-left.svg';
import arrow_circle_right from './arrow-circle-right.svg';
import arrow_circle_up from './arrow-circle-up.svg';
import arrow_circle_up_left from './arrow-circle-up-left.svg';
import arrow_circle_up_right from './arrow-circle-up-right.svg';
import arrow_down_left_lg from './arrow-down-left-lg.svg';
import arrow_down_left_md from './arrow-down-left-md.svg';
import arrow_down_left_sm from './arrow-down-left-sm.svg';
import arrow_down_lg from './arrow-down-lg.svg';
import arrow_down_md from './arrow-down-md.svg';
import arrow_down_right_lg from './arrow-down-right-lg.svg';
import arrow_down_right_md from './arrow-down-right-md.svg';
import arrow_down_right_sm from './arrow-down-right-sm.svg';
import arrow_down_sm from './arrow-down-sm.svg';
import arrow_down_up from './arrow-down-up.svg';
import arrow_expand from './arrow-expand.svg';
import arrow_left_lg from './arrow-left-lg.svg';
import arrow_left_md from './arrow-left-md.svg';
import arrow_left_right from './arrow-left-right.svg';
import arrow_left_sm from './arrow-left-sm.svg';
import arrow_reload_01 from './arrow-reload-01.svg';
import arrow_reload_02 from './arrow-reload-02.svg';
import arrow_right_lg from './arrow-right-lg.svg';
import arrow_right_md from './arrow-right-md.svg';
import arrow_right_sm from './arrow-right-sm.svg';
import arrow_shrink from './arrow-shrink.svg';
import arrow_sub_down_left from './arrow-sub-down-left.svg';
import arrow_sub_down_right from './arrow-sub-down-right.svg';
import arrow_sub_left_down from './arrow-sub-left-down.svg';
import arrow_sub_left_up from './arrow-sub-left-up.svg';
import arrow_sub_right_down from './arrow-sub-right-down.svg';
import arrow_sub_right_up from './arrow-sub-right-up.svg';
import arrow_sub_up_left from './arrow-sub-up-left.svg';
import arrow_sub_up_right from './arrow-sub-up-right.svg';
import arrow_undo_down_left from './arrow-undo-down-left.svg';
import arrow_undo_down_right from './arrow-undo-down-right.svg';
import arrow_undo_up_left from './arrow-undo-up-left.svg';
import arrow_undo_up_right from './arrow-undo-up-right.svg';
import arrow_unfold_less from './arrow-unfold-less.svg';
import arrow_unfold_more from './arrow-unfold-more.svg';
import arrow_up_left_lg from './arrow-up-left-lg.svg';
import arrow_up_left_md from './arrow-up-left-md.svg';
import arrow_up_left_sm from './arrow-up-left-sm.svg';
import arrow_up_lg from './arrow-up-lg.svg';
import arrow_up_md from './arrow-up-md.svg';
import arrow_up_right_lg from './arrow-up-right-lg.svg';
import arrow_up_right_md from './arrow-up-right-md.svg';
import arrow_up_right_sm from './arrow-up-right-sm.svg';
import arrow_up_sm from './arrow-up-sm.svg';
import arrow_upload_up from './arrow-upload-up.svg';

export const V2_ARROW_ICONS: { [char: string]: string } = {
  arrow_caret_circle_down,
  arrow_caret_circle_left,
  arrow_caret_circle_right,
  arrow_caret_circle_up,
  arrow_caret_down_md,
  arrow_caret_down_sm,
  arrow_caret_left_sm,
  arrow_caret_right_sm,
  arrow_caret_up_md,
  arrow_caret_up_sm,
  arrow_chevron_down,
  arrow_chevron_down_duo,
  arrow_chevron_left,
  arrow_chevron_left_duo,
  arrow_chevron_left_md,
  arrow_chevron_right,
  arrow_chevron_right_duo,
  arrow_chevron_right_md,
  arrow_chevron_up,
  arrow_chevron_up_duo,
  arrow_circle_down,
  arrow_circle_down_left,
  arrow_circle_down_right,
  arrow_circle_left,
  arrow_circle_right,
  arrow_circle_up,
  arrow_circle_up_left,
  arrow_circle_up_right,
  arrow_down_left_lg,
  arrow_down_left_md,
  arrow_down_left_sm,
  arrow_down_lg,
  arrow_down_md,
  arrow_down_right_lg,
  arrow_down_right_md,
  arrow_down_right_sm,
  arrow_down_sm,
  arrow_down_up,
  arrow_expand,
  arrow_left_lg,
  arrow_left_md,
  arrow_left_right,
  arrow_left_sm,
  arrow_reload_01,
  arrow_reload_02,
  arrow_right_lg,
  arrow_right_md,
  arrow_right_sm,
  arrow_shrink,
  arrow_sub_down_left,
  arrow_sub_down_right,
  arrow_sub_left_down,
  arrow_sub_left_up,
  arrow_sub_right_down,
  arrow_sub_right_up,
  arrow_sub_up_left,
  arrow_sub_up_right,
  arrow_undo_down_left,
  arrow_undo_down_right,
  arrow_undo_up_left,
  arrow_undo_up_right,
  arrow_unfold_less,
  arrow_unfold_more,
  arrow_up_left_lg,
  arrow_up_left_md,
  arrow_up_left_sm,
  arrow_up_lg,
  arrow_up_md,
  arrow_up_right_lg,
  arrow_up_right_md,
  arrow_up_right_sm,
  arrow_up_sm,
  arrow_upload_up,
};

export const V2_ARROW_ICON_NAMES: string[] = Object.keys(V2_ARROW_ICONS);
